import Vue from 'vue'

export default Vue.extend({
  name: 'FeedbackDialog',
  data() {
    return {
      feedback: ''
    }
  },
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'この問題へのご意見・ご指摘事項'
    },
    cancel: {
      type: String,
      default: 'キャンセル'
    },
    confirm: {
      type: String,
      default: '送信する'
    },
    cancelColor: {
      type: String,
      default: 'green'
    },
    confirmColor: {
      type: String,
      default: 'green'
    },
    questionName: {
      type: String,
      default: '問題'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      this.$emit('submit', this.feedback)
      this.feedback = ''
      this.close()
    }
  }
})
